import { headerWidth } from "../../R";
import useIsMobile from "../../hooks/device/useIsMobile";

interface MaxWidthLayoutProps {
  readonly children: React.ReactNode;
}

function MaxWidthLayout({ children }: MaxWidthLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <div
      css={{
        maxWidth: isMobile ? "100vw" : headerWidth,
        width: "100%",
        margin: "auto",
        position: "relative",
        // allows rocket animation to work
        zIndex: 2,
      }}
    >
      {children}
    </div>
  );
}

export default MaxWidthLayout;
